import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LENS_TYPES } from 'src/app/helpers/lenses.helper';
import { CompanyLenses } from 'src/app/models/company-lenses.model';

@Component({
    selector: 'app-go-single-vision',
    templateUrl: './single-vision.component.html',
    styleUrls: ['./single-vision.component.scss'],
    standalone: false
})
export class SingleVisionComponent implements OnInit {

  @Input() isAgainstRecommendation: boolean = false;
  @Input() svLenses: CompanyLenses[] = [];
  @Output() lensTypeChangeEvent = new EventEmitter<LENS_TYPES>();
  @Output() addLensToCartEvent = new EventEmitter<CompanyLenses>();

  public showGuidedSv: boolean = false;
  public lowerGradeSVOption!: CompanyLenses;
  public higherGradeSVOption!: CompanyLenses;

  constructor() { }

  ngOnInit(): void {
    this.setSvLensDisplay();
  }

  setSvLensDisplay() {
    if (this.svLenses.length > 1) {
      const orderedSvLenses = this.svLenses.sort((a,b) => (a.price < b.price ? -1 : 1));   
      this.lowerGradeSVOption = orderedSvLenses[0];
      this.higherGradeSVOption = orderedSvLenses[1];
    } else {
      // they can immediately proceed to the selection here
      if (!this.isAgainstRecommendation) {
        this.selectLens(this.svLenses[0]);
      }
    }
  }

  showBifocalProgressive() {
    this.lensTypeChangeEvent.emit(LENS_TYPES.bifocalProg);
  }

  selectLens(selectedLens: CompanyLenses) {
    this.addLensToCartEvent.emit(selectedLens);
  }

  onAcceptedWarning() {   
    if (this.svLenses.length == 1) {
      this.selectLens(this.svLenses[0]);
    } else {
      this.showGuidedSv = true;
    }
  }

}
